import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faXmark,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import constants from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";


const MobileNav = ({ pathname }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [headerPosition, setHeaderPosition] = useState(-100);
  const [headerTiming, setHeaderTiming] = useState(0.8);
  const { getCurrentLogo } = useUserParams();

  useEffect(() => {
    // Reset menu state when pathname changes
    setIsMenuOpen(false);
    setHeaderPosition(-100);
    document.body.style.overflow = "auto";
  }, [pathname]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setHeaderPosition(isMenuOpen ? -100 : 0);
    document.body.style.overflow = !isMenuOpen ? "hidden" : "auto";
  };

  const navClick = () => {
    setHeaderPosition(-100);
    setHeaderTiming(0);
    setTimeout(() => {
      setHeaderTiming(0.8);
    }, 100);
    if (typeof window != "undefined" && window.document) {
      document.body.style.overflow = "auto";
    }
  };

  const navItems = [
    { href: "/", label: "Home" },
    { href: "/about", label: "About" },
    { href: "/calculator", label: "Mortgage Calculator" },
    { href: "/listings", label: "Listings" },
    { href: "/evaluation", label: "Free Home Evaluation" },
    { href: "/real-estate-reports", label: "Free Real Estate Reports" },
    { href: "/contact", label: "Contact" },
  ];

  return (
    <>
      <div className="relative w-full h-32 z-30 grid sm:grid-cols-3 grid-cols-[1fr_50%_1fr] items-center bg-transparent">
        <button
          onClick={toggleMenu}
          className="z-30 text-2xl px-4 text-ocean hover:text-logo-main cursor-pointer transition-colors duration-200"
        >
          <FontAwesomeIcon
            icon={isMenuOpen ? faXmark : faBars}
            className="w-7 h-7"
          />
        </button>
        <div className="flex justify-center">
          <img
            src={getCurrentLogo()}
            alt="Logo"  
            width={88}
            height={88}
            className="z-30 h-20"
          />
        </div>
      </div>

      <nav
        style={{
          transition: `translate ${headerTiming}s cubic-bezier(0, .52, 0, 1)`,
          translate: `${headerPosition}vw`,
        }}
        className={`flex flex-col gap-12 px-6 py-9 bg-sky/95 rounded-r-2xl shadow-xl border-l border-sky/30 fixed z-20 w-[75%] h-full child:tracking-wider child:font-bold font-mont`}
      >
        {navItems.map((item) => (
          <Link
            key={item.href}
            to={item.href}
            onClick={navClick}
            className={`text-lg px-2 ${
              pathname === item.href
                ? "underline decoration-logo-main decoration-4 underline-offset-8 text-logo-main"
                : "text-ocean hover:text-logo-main transition-colors duration-200"
            }`}
          >
            {item.label}
            {pathname !== item.href && (
              <FontAwesomeIcon
                className="pl-4 w-4 h-4 inline-block text-ocean"
                icon={faAngleRight}
              />
            )}
          </Link>
        ))}
      </nav>
    </>
  );
};

export default MobileNav;
